import React, { Component } from 'react';

import Sheet1 from '../dataSheets/sheet1.js';
import Sheet2 from '../dataSheets/sheet2.js';
import Sheet3 from '../dataSheets/sheet3.js';
import Sheet4 from '../dataSheets/sheet4.js';
import Sheet5 from '../dataSheets/sheet5.js';
import Sheet6 from '../dataSheets/sheet6.js';
import Sheet7 from '../dataSheets/sheet7.js';

import '../App.css';

class CannabisLight extends Component {
  render() {
    return (
      <div className="App">
          <div className ="prod-title">
            <h1>Varietà di Cannabis light</h1>
            <br />
          </div>


          <div className="prod-typo">
            <Sheet1 />
            <Sheet2 />
            <Sheet3 />
            <Sheet4 />
            <Sheet5 />
            <Sheet6 />
            <Sheet7 />
          </div>
      </div>
    )
  }
}


export default CannabisLight;
